import React from 'react';
import { Menu as MuiMenu, MenuItem } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import { MenuDirection, MenuPlacement } from './types';
var useStyles = makeStyles(function () { return ({
    list: function (props) { return ({
        minWidth: props.minWidth || 'auto',
    }); },
    disabledItem: {
        opacity: 0.5,
        cursor: 'default',
    },
}); });
/**
 * @deprecated
 */
var Menu = function (props) {
    var menuDirection = props.menuDirection, _a = props.menuPlacement, menuPlacement = _a === void 0 ? MenuPlacement.Left : _a, items = props.items, anchorEl = props.anchorEl, open = props.open, onClose = props.onClose;
    var classes = useStyles(props);
    // get the anchor origin (position of menu) related to configuration
    var getAnchorOrigin = function () {
        var vertical = 'top';
        if (menuDirection === MenuDirection.Below) {
            vertical = 'bottom';
        }
        return {
            vertical: vertical,
            horizontal: menuPlacement,
        };
    };
    // get the transform origin (position of menu) related to configuration
    var getTransformOrigin = function () {
        var vertical = 'top';
        if (menuDirection === MenuDirection.Above) {
            vertical = 'bottom';
        }
        return {
            vertical: vertical,
            horizontal: menuPlacement,
        };
    };
    // render each item
    var renderMenuItem = function (item) {
        var fireAction = function () {
            if (!item.disabled) {
                onClose();
                if (item.action)
                    item.action();
            }
        };
        var menuItem = (React.createElement(React.Fragment, null,
            item.icon ? React.createElement(item.icon, { title: "".concat(item.label, " Title"), style: { paddingRight: 10 } }) : null,
            item.label ? item.label : null));
        return (
        // need to do the disabled with class, because if we use the property, the tooltip won't work
        React.createElement(MenuItem, { onClick: fireAction, key: item.label, className: item.disabled ? classes.disabledItem : '', "data-testid": item.elementId || '' }, item.WrapperComponent ? React.createElement(item.WrapperComponent, null, menuItem) : menuItem));
    };
    return (React.createElement(MuiMenu, { keepMounted: true, anchorEl: anchorEl, getContentAnchorEl: null, classes: {
            list: classes.list,
        }, open: open, onClose: onClose, anchorOrigin: getAnchorOrigin(), transformOrigin: getTransformOrigin() }, items.map(renderMenuItem)));
};
export default Menu;
//# sourceMappingURL=Menu.js.map